// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { Amulet } from '@daml.js/splice-amulet/lib/Splice/Amulet';
import { useLedgerApiClient } from '../../../contexts/LedgerApiContext';
import { useModuleParty } from '../../../contexts/ModuleContext';
import TemplateContract from '../../../utils/TemplateContract';
import { useQueryWithOptions } from '../../other/useQueryWithOptions';

const useCoins: () => UseQueryResult<TemplateContract<Amulet>[], string> = () => {
  const ledgerApi = useLedgerApiClient();
  const party = useModuleParty();

  return useQueryWithOptions({
    queryKey: ['queryCoins', party],
    select: (data: TemplateContract<Amulet>[]) => data.filter((d) => d.payload.owner === party),
    queryFn: async (_, options) => {
      return ledgerApi.query(options, Amulet);
    },
  });
};

export default useCoins;
